import Echo from '../websocket';

type ReconnectListener = () => void;

const OFFLINE_STATES = ['unavailable', 'disconnected', 'failed'];

const listeners = new Set<ReconnectListener>();

let isBound = false;
let wasOffline = false;

const getConnection = () => (Echo as any)?.connector?.pusher?.connection ?? null;

/**
 * Pusher does not replay the events published while the socket was down, so every
 * consumer that keeps state in sync through websocket deltas has to resynchronise
 * itself once the connection is restored.
 */
const bindConnectionEvents = () => {
  if (isBound) {
    return;
  }

  const connection = getConnection();

  if (!connection) {
    return;
  }

  isBound = true;

  connection.bind('state_change', ({ current }: { previous: string; current: string }) => {
    if (OFFLINE_STATES.includes(current)) {
      wasOffline = true;
      return;
    }

    if (current !== 'connected' || !wasOffline) {
      return;
    }

    wasOffline = false;
    listeners.forEach((listener) => listener());
  });
};

export const isWebSocketConnected = () => getConnection()?.state === 'connected';

/**
 * Subscribes to websocket reconnections. Returns the unsubscribe function.
 */
export const onWebSocketReconnect = (listener: ReconnectListener) => {
  bindConnectionEvents();
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};
